import { List } from "../Components/index.js";

export default [
    {
        path: "/account/master/ledger",
        component: List,
        name: "account.master.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    // { path: '/account/master/ledger/create', component: Create, name: 'account.master.ledger.create'},
    // { path: '/account/master/ledger/:id/edit', component: Edit, name: 'account.master.ledger.edit'},
];
